import { Link } from "./usePath";

function VideoBox({ video, handleVote, showInfo = true }) {
  return (
    <div className="video-column">
      {showInfo && (
        <div
          style={{
            textAlign: "center",
            marginBottom: 8,
            fontSize: 16,
          }}
        >
          <Link to={`/video/${video.id}`} style={{ fontWeight: 600 }}>
            {video.name || "??"}
          </Link>
          {video.school && (
            <>
              {" · "}
              <Link to={`/school/${encodeURIComponent(video.school)}`}>
                {video.school}
              </Link>
            </>
          )}
        </div>
      )}
      <div className="video-wrapper">
        <iframe
          title={`${video.videoId}`}
          src={`https://www.youtube.com/embed/${video.videoId}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </div>
      {handleVote && (
        <button className="vote-button" onClick={() => handleVote(video.id)}>
          This video is better
        </button>
      )}
    </div>
  );
}

export default VideoBox;
